import { render } from "./CompanyTutorials.vue?vue&type=template&id=1b329169&scoped=true"
import script from "./CompanyTutorials.vue?vue&type=script&lang=js"
export * from "./CompanyTutorials.vue?vue&type=script&lang=js"

import "./CompanyTutorials.vue?vue&type=style&index=0&id=1b329169&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b329169"]])

export default __exports__